const headings = document.querySelectorAll('.sitemap-block__heading');

headings.forEach((each)=> {
    each.addEventListener('click', ()=> {        
    console.log("Heading Clicked");
    var sitemapContainer = each.parentElement
    console.log(sitemapContainer)
     const sitemapContent = document.querySelectorAll('.sitemap-block--items');
    if (sitemapContent) {
        headings.forEach((eachHeading)=> eachHeading.style.paddingTop = '0' );
        each.style.paddingTop = '24px';
        each.style.paddingBottom = '24px';
        sitemapContent.forEach((eachBlock)=> eachBlock.classList.toggle('is--active'));
        sitemapContent.forEach((eachBlock)=> eachBlock.classList.toggle('hidden'));
    } 
    })
})